module.exports = __webpack_public_path__ + "img/imgStep01.4720eed3.png";